import { IAIVideoModel } from 'types/aiVideo'

export const getModelDisplayName = (
  modelCode: string,
  models: IAIVideoModel[]
): string => {
  return (
    models.find(modelItem => modelItem.model === modelCode)?.name ?? modelCode
  )
}
